var React = require('react');

function Faq (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"12","cy":"12","r":"10","key":0}),React.createElement("path",{"d":"M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3","key":1}),React.createElement("line",{"x1":"12","y1":"17","x2":"12.01","y2":"17","key":2})]);
}

Faq.defaultProps = {"viewBox":"0 0 24 24","width":"48","height":"48","stroke":"currentColor","strokeWidth":"2","fill":"none","strokeLinecap":"round","strokeLinejoin":"round","className":"faq"};

module.exports = Faq;

Faq.default = Faq;
